
import React, { useState } from "react";
import SimpleBar from 'simplebar-react';
import { useLocation } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faFileAlt, faSignOutAlt, faTable, faTimes, faHome, faStepBackward, faTransgender, faServer, faTachometerAlt, faUserShield, faIdBadge, faTicketAlt } from "@fortawesome/free-solid-svg-icons";
import { isSuperAdminUser } from '../helper/adminSession';
import { Nav, Badge, Image, Button, Dropdown, Accordion, Navbar } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';

import { Routes } from "../routes";
import ReactHero from "../assets/img/technologies/react-hero-logo.svg";
import ProfilePicture from "../assets/img/team/profile-picture-3.jpg";

export default (props = {}) => {
  const location = useLocation();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const showClass = show ? "show" : "";

  const onCollapse = () => setShow(!show);

  const permission = localStorage.getItem('permission')

  const CollapsableNavItem = (props) => {
    const { eventKey, title, icon, children = null } = props;
    const defaultKey = pathname.indexOf(eventKey) !== -1 ? eventKey : "";

    return (
      <Accordion as={Nav.Item} defaultActiveKey={defaultKey}>
        <Accordion.Item eventKey={eventKey}>
          <Accordion.Button as={Nav.Link} className="d-flex justify-content-between align-items-center">
            <span>
              <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span>
              <span className="sidebar-text">{title}</span>
            </span>
          </Accordion.Button>
          <Accordion.Body className="multi-level">
            <Nav className="flex-column">
              {children}
            </Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };

  const NavItem = (props) => {
    const { title, link, external, target, icon, image, badgeText, badgeBg = "secondary", badgeColor = "primary" } = props;
    const classNames = badgeText ? "d-flex justify-content-start align-items-center justify-content-between" : "";
    const navItemClassName = link === pathname ? "active" : "";
    const linkProps = external ? { href: link } : { as: Link, to: link };

    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        <Nav.Link {...linkProps} target={target} className={classNames}>
          <span>
            {icon ? <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span> : null}
            {image ? <Image src={image} width={20} height={20} className="sidebar-icon svg-icon" /> : null}

            <span className="sidebar-text">{title}</span>
          </span>
          {badgeText ? (
            <Badge pill bg={badgeBg} text={badgeColor} className="badge-md notification-count ms-2">{badgeText}</Badge>
          ) : null}
        </Nav.Link>
      </Nav.Item>
    );
  };

  const permissionPoint = permission.split('').reduce((x, it) => {
    return parseInt(x) + parseInt(it)
  })

  const superAdmin = isSuperAdminUser()

  return (
    <>
      <Navbar expand={false} collapseOnSelect variant="dark" className="navbar-theme-primary px-4 d-md-none">
        <Navbar.Brand className="me-lg-5" as={Link} to={Routes.Overview.path}>
          <Image src={ReactHero} className="navbar-brand-light" />
        </Navbar.Brand>
        <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar className={`collapse ${showClass} sidebar d-md-block bg-primary text-white`}>
          <div className="sidebar-inner px-4 pt-3">
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
              <div className="d-flex align-items-center">
                <div className="user-avatar lg-avatar me-4">
                  <Image src={ProfilePicture} className="card-img-top rounded-circle border-white" />
                </div>
                <div className="d-block">
                  <h6>Hi, Jane</h6>
                  <Button as={Link} variant="secondary" size="xs" to={Routes.Signin.path} className="text-dark">
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Sign Out
                  </Button>
                </div>
              </div>
              <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>
            <Nav className="flex-column pt-3 pt-md-0">
              {(permissionPoint > 1) &&
                <NavItem title="Quay về" link={Routes.Overview.path} icon={faStepBackward} />
              }

              <NavItem title="Trang chủ" link={Routes.SettingOverview.path} icon={faHome} />

              {/* <Dropdown.Divider className="my-3 border-indigo" /> */}

              {/* <CollapsableNavItem eventKey="commons/" title="Thông tin chung" icon={faBook}> */}
              <NavItem title="USB" link={Routes.SettingDevices.path} />
              <NavItem title="Trò chơi" link={Routes.SettingGames.path} />
              <NavItem title="Quảng cáo" link={Routes.SettingBanner.path} />
              <NavItem title="Tài khoản thanh toán" link={Routes.SettingAccount.path} />
              <NavItem title="Hình thức thanh toán" link={Routes.SettingPaymentMethod.path} />
              <NavItem title="Ngân hàng" link={Routes.SettingBank.path} />
              <NavItem title="Thông báo" link={Routes.SettingNotification.path} />
              <NavItem title="Điều khoản sử dụng" link={Routes.SettingPrivacy.path} />
              <NavItem title="Liên hệ" link={Routes.SettingContact.path} />
              <NavItem title="Bảo trì" link={Routes.SettingMaintained.path} icon={faTransgender} />
              <NavItem title="Chia vé" link={Routes.SettingTicketRoll.path} icon={faTicketAlt} />
              <NavItem title="Hàng đợi worker" link={Routes.SettingWorkerQueue.path} icon={faServer} />
              <NavItem title="Hiệu năng server" link={Routes.SettingServerBenchmark.path} icon={faTachometerAlt} />
              {superAdmin &&
                <NavItem title="Quản trị viên" link={Routes.AdminManagement.path} icon={faUserShield} />
              }
              {superAdmin &&
                <NavItem title="Nhân viên in vé" link={Routes.TicketEmployeeManagement.path} icon={faIdBadge} />
              }
              {/* </CollapsableNavItem> */}
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};
